import { useContext } from 'react';
import { SubscriptionContext } from '../contexts/SubscriptionContext';

/**
 * Custom hook to access subscription context
 * @returns {Object} Subscription context value
 * @throws {Error} If used outside of SubscriptionProvider
 */
export const useSubscription = () => {
  const context = useContext(SubscriptionContext);

  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }

  return context;
};

export default useSubscription;
